export default import.meta.ROLLUP_FILE_URL_C$4kQWR6NkPB83QJdL0WCQ;